import React, { Component } from "react";
import { Link } from "react-router-dom";
import { Button } from "reactstrap";
import CustomModal from "../../../components/custommodal/custommodal";
import Icon from "../../../components/icon";
import moment from "moment";
import { env, env_url } from "../../../environments/env";
import HttpServices from "../../../environments/environment_urls";
import { applicationTransmissionFlow, convertDateFormat } from "../../../functions/common";
import CryptoJS from "crypto-js";
class Footer extends Component {
  constructor(props) {
    super(props);

    this.state = {  
      lastLoggedIn:""
    };
    this.termsCond = React.createRef();
  }
  

  submitConfirmation = () => {
    this.termsCond.current.toggleModal();
  };
  componentDidMount=()=>{
        this.setState({lastLoggedIn:localStorage.getItem("lastLogin")});
  };  
  render() {
    return (
      <footer>
        <div className="footer-block">
          <div className="copyright">
            Copyright © {new Date().getFullYear()} Prokraya Tech Pvt Ltd. All rights reserved.
            {/* | <Link to="/">Privacy Policy</Link> |{" "} */}
            {/* <Link onClick={this.submitConfirmation}>Terms and Conditions</Link> */}
          </div>
          {this.state.lastLoggedIn?
          <div className="help-block">
            {/* <Icon iconName="help mr-1" iconSize={20} /> */}
            Last LoggedIn : {convertDateFormat(this.state.lastLoggedIn,"DD/MM/YYYY hh:mm")}
          </div>:""}
        </div>
        <CustomModal
          ref={this.termsCond}
          className="confirmation"
          content={
            <div className="">
              <div className="content-title" style={{ textAlign: "center" }}>
                Terms and Conditions
              </div>
              <div>
                <p>
                  Please read the following terms and conditions before using
                  the HFC Supplier Onboarding System. By logging into and using
                  the HFC Supplier Onboarding System, the Supplier agrees to
                  these terms and conditions. HFC reserves the right to update
                  these terms and conditions at any time without notice to the
                  Supplier
                </p>
                <p>
                  <strong>1. DEFINITIONS</strong>
                </p>
                <p>
                  &nbsp; &nbsp;1.1 &ldquo;<strong>HFC</strong>&rdquo; means
                  Hassad Food Company Q.P.S.C. and its Affiliates.
                </p>
                <p>
                  &nbsp; &nbsp;1.2 &ldquo;
                  <strong>HFC Supplier Onboarding System&rdquo;</strong> means
                  the online supplier registration / onboarding <br></br> &nbsp;
                  &nbsp; &nbsp; &nbsp;system, which use is offered under license
                  by the terms of this agreement.
                </p>
                <p>
                  &nbsp; &nbsp;1.3<strong>&nbsp;&ldquo;Affiliate&rdquo;</strong>{" "}
                  where used in this terms and conditions means, with respect to
                  HFC, any person &nbsp; &nbsp; &nbsp; &nbsp; or entity that is
                  directly or indirectly Controlling, Controlled by, or under
                  common Control &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; with
                  the HFC, where "<strong>Control</strong>" and derivative terms
                  mean the possession, directly or <br></br> &nbsp; &nbsp;
                  &nbsp; &nbsp; indirectly, of the power to direct or cause the
                  direction of the management and policies of <br></br> &nbsp;
                  &nbsp; &nbsp; &nbsp;such person or entity, whether through the
                  ownership of voting securities, by contract, or <br></br>{" "}
                  &nbsp; &nbsp; &nbsp; &nbsp;otherwise
                </p>
                <p>
                  &nbsp; &nbsp;1.4 &ldquo;<strong>Supplier</strong>&rdquo; means
                  any natural person or entity who enters or uses the HFC
                  Supplier <br></br> &nbsp; &nbsp; &nbsp; &nbsp;Onboarding
                </p>
                <p>
                  &nbsp; &nbsp;1.5<strong> &ldquo;Employee&rdquo; </strong>means
                  any individual who works under the supervision or control of
                  the <br></br> &nbsp; &nbsp; &nbsp; &nbsp;Supplier.
                </p>
                <p>
                  <strong>2. TERMS OF USE</strong>
                </p>
                <p>
                  &nbsp; &nbsp;2.1 The Supplier&rsquo;s representative warrants
                  that he/she is authorised on behalf of the Supplier <br></br>{" "}
                  &nbsp; &nbsp; &nbsp; &nbsp;to agree to these terms and
                  conditions and to represent the Supplier when using the HFC{" "}
                  <br></br> &nbsp; &nbsp; &nbsp; &nbsp;Supplier Onboarding
                </p>
                <p>
                  &nbsp; &nbsp;2.2 The HFC Supplier Onboarding System, its
                  design and operating systems are the intellectual <br></br>{" "}
                  &nbsp; &nbsp; &nbsp; &nbsp;property of HFC, and the Supplier
                  shall not copy nor reproduce any element of the HFC <br></br>{" "}
                  &nbsp; &nbsp; &nbsp; &nbsp;Supplier Onboarding System nor
                  infringe HFC intellectual property rights in respect of the
                  <br></br> &nbsp; &nbsp; &nbsp; &nbsp;HFC Supplier Onboarding
                  System in any
                </p>
                <p>
                  &nbsp; &nbsp;2.3 The Supplier agrees that all information
                  provided to HFC by the Supplier via the HFC <br></br> &nbsp;
                  &nbsp; &nbsp; &nbsp;Supplier Onboarding System is current,
                  true and accurate.
                </p>
                <p>
                  &nbsp; &nbsp;2.4 It is the Supplier&rsquo;s responsibility to
                  immediately notify HFC concerning any changes to the
                  <br></br> &nbsp; &nbsp; &nbsp; &nbsp;Supplier&rsquo;s contact
                  information, bank account details, and/or other
                  businessinformation.
                </p>
                <p>
                  &nbsp; &nbsp;2.5 HFC may independently verify any information
                  provided and request any supporting <br></br> &nbsp; &nbsp;
                  &nbsp; &nbsp;evidence from the Supplier, which the Supplier
                  shall supply to HFC without delay.
                </p>
                <p>
                  &nbsp; &nbsp;2.6 HFC reserves the right to accept or reject
                  applications in its absolute discretion. Any act <br></br>{" "}
                  &nbsp; &nbsp; &nbsp; &nbsp;below on the part of the Supplier
                  may result in deregistration and/or prohibition from the{" "}
                  <br></br> &nbsp; &nbsp; &nbsp; &nbsp;HFC Supplier Onboarding
                  System
                  <strong>:</strong>
                </p>
                <p>
                  &nbsp; &nbsp; &nbsp; &nbsp; 2.6.1 The submission of false
                  and/or forged documentation on the HFC Supplier
                  <br></br> &nbsp; &nbsp; &nbsp; &nbsp;Onboarding System.
                </p>
                <p>
                  &nbsp; &nbsp; &nbsp; &nbsp; 2.6.2 conviction of the Supplier
                  of any crime of corruption or financial dishonesty
                  <br></br> &nbsp; &nbsp; &nbsp; &nbsp;whatsoever in any
                  jurisdiction.
                </p>
                <p>
                  &nbsp; &nbsp; &nbsp; &nbsp; 2.6.3 infringement by the Supplier
                  of HFC or a third party&rsquo;s intellectual property right.
                </p>
                <p>
                  &nbsp; &nbsp; &nbsp; &nbsp; 2.6.4 direct and/or indirect
                  price-fixing by the Supplier.
                </p>
                <p>
                  &nbsp; &nbsp; &nbsp; &nbsp; 2.6.5 misrepresentation to HFC of
                  the quality of goods and/or services provided and/or to
                  <br></br> &nbsp; &nbsp; &nbsp; &nbsp;be provided by the
                  Supplier.
                </p>
                <p>
                  &nbsp; &nbsp; &nbsp; &nbsp; 2.6.6 any breach of any agreement
                  between the Supplier and HFC; and
                </p>
                <p>
                  &nbsp; &nbsp; &nbsp; &nbsp; 2.6.7 any outdated information
                  provided by the Supplier.
                </p>
                <p>
                  &nbsp; &nbsp;2.7 The HFC Supplier Onboarding System is
                  provided &ldquo;as is&rdquo; and use thereof is at the
                  Supplier&rsquo;s
                  <br></br> &nbsp; &nbsp; &nbsp; &nbsp;own risk
                </p>
                <p>
                  &nbsp; &nbsp;2.8 No warranty, representation, guarantee
                  whether express or implied, is given by HFC in
                  <br></br> &nbsp; &nbsp; &nbsp; &nbsp;respect of the operation
                  of the HFC Supplier Onboarding
                </p>
                <p>
                  &nbsp; &nbsp;2.9 HFC accepts no liability whatsoever for any
                  loss or damage (whether direct and/or indirect)
                  <br></br> &nbsp; &nbsp; &nbsp; &nbsp;incurred by the Supplier
                  when using the HFC Supplier Onboarding System for any reason
                  <br></br> &nbsp; &nbsp; &nbsp; &nbsp;whatsoever, including but
                  not limited to:
                </p>
                <p>
                  &nbsp; &nbsp; &nbsp; &nbsp; 2.9.1 unauthorised access,
                  interception and/or information breach of the HFC Supplier
                  <br></br> &nbsp; &nbsp; &nbsp; &nbsp;Onboarding System by a
                  third party.
                </p>
                <p>
                  &nbsp; &nbsp; &nbsp; &nbsp; 2.9.2 any inaccuracy, error,
                  delay, or omission concerning any data, information and/or
                  <br></br> &nbsp; &nbsp; &nbsp; &nbsp;message displayed on
                  and/or transmitted via the HFC Supplier Onboarding System.
                </p>
                <p>
                  &nbsp; &nbsp; &nbsp; &nbsp; 2.9.3 any electronic virus
                  transmitted to the Supplier&rsquo;s electronic systems via the
                  HFC <br></br> &nbsp; &nbsp; &nbsp; &nbsp;Supplier Onboarding
                  System.
                </p>
                <p>
                  &nbsp; &nbsp; &nbsp; &nbsp; 2.9.4 unavailability and/or
                  suspension and/or removal of the HFC Supplier Onboarding
                  <br></br> &nbsp; &nbsp; &nbsp; &nbsp;System.
                </p>
                <p>
                  &nbsp; &nbsp; &nbsp; &nbsp; 2.9.5 fitness for purpose of the
                  HFC Supplier Onboarding System.
                </p>
                <p>
                  &nbsp; &nbsp; &nbsp; &nbsp; 2.9.6 failure by the Supplier to
                  comply with these terms and conditions; and/or
                </p>
                <p>
                  &nbsp; &nbsp; &nbsp; &nbsp; 2.9.7 any other reason not
                  directly related to HFC&rsquo;s gross negligence and wilful
                  misconduct.
                </p>
                <p>
                  &nbsp; &nbsp;2.10 The Supplier agrees that these terms and
                  conditions will apply unless a written <br></br> &nbsp; &nbsp;
                  &nbsp; &nbsp;agreement has been approved and signed by a duly
                  authorised HFC authorised <br></br> &nbsp; &nbsp; &nbsp;
                  &nbsp;representative. These terms and conditions shall prevail
                  in the event the Supplier submits its <br></br> &nbsp; &nbsp;
                  &nbsp; &nbsp;own terms and conditions (including but not
                  limited to the Supplier&rsquo;s quotation, standard <br></br>{" "}
                  &nbsp; &nbsp; &nbsp; &nbsp;terms and conditions of contract,
                  or invoice terms and conditions).
                </p>
                <p>
                  &nbsp; &nbsp;2.11 Supplier registration requires an explicit
                  invitation from HFC, with HFC having the right to <br></br>{" "}
                  &nbsp; &nbsp; &nbsp; &nbsp;terminate access. Access must not
                  be shared, and information provided must be current, <br></br>{" "}
                  &nbsp; &nbsp; &nbsp; &nbsp;true, and accurate. If Employee no
                  longer works for Supplier, use ceases immediately.
                </p>
                <p>
                  &nbsp; &nbsp;2.12 Personal details provided to HFC through the
                  HFC Supplier Onboarding System used in <br></br> &nbsp; &nbsp;
                  &nbsp; &nbsp;accordance with the applicable laws in the state
                  of Qatar.
                </p>
                <p>
                  &nbsp; &nbsp;2.13 The Supplier agrees that by completing and
                  submitting its personal information to HFC <br></br> &nbsp;
                  &nbsp; &nbsp; &nbsp;through the HFC Supplier Onboarding System
                  that it expressly provides its consent thereto <br></br>{" "}
                  &nbsp; &nbsp; &nbsp; &nbsp;for the purposes of HFC&rsquo;s
                  supplier vetting.
                </p>
                <p>
                  &nbsp; &nbsp;2.14 HFC does not make any warranties or
                  representations that the information provided by <br></br>{" "}
                  &nbsp; &nbsp; &nbsp; &nbsp;the Supplier to HFC through the HFC
                  Supplier Onboarding System shall be safe and secure.
                </p>
                <p>
                  &nbsp; &nbsp;2.15 HFC shall not be liable for costs incurred
                  by Suppliers to obtain professional advice <br></br> &nbsp;
                  &nbsp; &nbsp; &nbsp;relating to these terms and conditions.
                </p>
                <p>
                  &nbsp; &nbsp;2.16 If any invalid, unenforceable or illegal
                  provision in these terms and conditions would be <br></br>{" "}
                  &nbsp; &nbsp; &nbsp; &nbsp;valid, enforceable, or legal if
                  some part of it were deleted, the provision shall apply with
                  <br></br> &nbsp; &nbsp; &nbsp; &nbsp;whatever modification is
                  necessary to make it valid, enforceable, and legal.
                </p>
                <p>
                  &nbsp; &nbsp;2.17 Should any dispute of whatever nature arise
                  from or in connection with these terms and <br></br> &nbsp;
                  &nbsp; &nbsp; &nbsp;conditions, then the dispute shall, in the
                  first instance be referred to the Supplier&rsquo;s duly
                  <br></br> &nbsp; &nbsp; &nbsp; &nbsp;authorised representative
                  and the Head of Procurement at HFC who will attempt to resolve{" "}
                  <br></br> &nbsp; &nbsp; &nbsp; &nbsp;the dispute.
                </p>
                <p>
                  &nbsp; &nbsp;2.18 The laws of the State of Qatar shall govern
                  these terms and conditions. Any dispute <br></br> &nbsp;
                  &nbsp; &nbsp; &nbsp;arising from these terms and conditions
                  shall be submitted to the exclusive jurisdiction of <br></br>{" "}
                  &nbsp; &nbsp; &nbsp; &nbsp;the State of Qatar Courts unless
                  the parties agree to resolve such dispute by mediation{" "}
                  <br></br> &nbsp; &nbsp; &nbsp; &nbsp;and/or arbitration in
                  terms of a separate mediation and/or arbitration agreement
                  between <br></br> &nbsp; &nbsp; &nbsp; &nbsp;the parties.
                </p>
                <p>
                  &nbsp; &nbsp;2.19 Should you have any questions regarding
                  these terms and conditions, please contact HFC <br></br>{" "}
                  &nbsp; &nbsp; &nbsp; &nbsp;Procurement Services at: E-mail
                  address: <u>hfc-procurement@hassad.com</u>
                </p>
              </div>
              <div className="text-center">
                <Button
                  className="btn btn-outline-primary mr-3"
                  onClick={this.submitConfirmation}
                >
                  Close
                </Button>
              </div>
            </div>
          }
        />
      </footer>
    );
  }
}

export default Footer;
